import React, { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import { CandidateStatus } from '../../common/enums/CandidateStatus';

interface ICustomBadge {
  min?: number;
  max?: number;
  value?: number;
  className?: string;
  status?: CandidateStatus;
}

const CustomBadge: FunctionComponent<ICustomBadge> = ({
  min = 0,
  max = 0,
  value = -1,
  className,
  children,
  status
}) => {
  const variant = () => {
    switch (status) {
      case CandidateStatus.InactiveHired:
        return styles.blue;
      case CandidateStatus.InactiveHibernate:
        return styles.purple;
      default:
    }
    if (Number(value) < Number(min)) {
      return styles.gray;
    }
    if (Number(value) >= Number(max)) {
      return styles.green;
    }
    return styles.yellow;
  };

  return (
    <div className={`custom-badge ${variant()} ${className}`}>
      {children}
    </div>
  );
};

export default CustomBadge;
